export default {
  'Start at': 'から開始',
  'Set to current time': '現在の時刻に設定',
  'Audio volume': 'オーディオボリューム',
  'Video volume': 'ビデオボリューム',
  'Trim audio': '音声をトリム',
  'Audio will end with the video': '音声は動画とともに終了します',
  'Trim': 'トリム',
}